import { mapEventToAppsFlyerEvent } from '@bridebook/web/lib/track-utils/mappers/event-to-appsflyer-event';
import { ITrackingMapper } from '@bridebook/web/lib/track-utils/tracking-mappers';

export const searchResultsLoadedMapper: ITrackingMapper<{
  supplierType: string;
  countryCode: string;
}> = ({ event, payload }) => [
  mapEventToAppsFlyerEvent(event),
  {
    af_content_type: payload.supplierType,
    af_country: payload.countryCode,
  },
];
